// @flow

import * as React from "react";
import { FormattedMessage } from "react-intl";

export function I18NBack() {
  return <FormattedMessage id="i18n.back" defaultMessage="Back" />;
}
